import { fg } from '@atlassian/jira-feature-gating';

const JiraTimelineJpdRoadmapRecommendationRelayProvider = {
	get(): boolean {
		return fg('jira_timeline_jpd_roadmap_recommendation');
	},
};

export default JiraTimelineJpdRoadmapRecommendationRelayProvider;
